export const enum VaccinationTypesEnum {
    Covid19 = 1,
    Flu = 2
}

// profession ids for Nurse Practitioner = 3, Physician = 59, Physician Assistant = 72
export const locumsPhysicianProfessionCodes = [3, 59, 72];

//Certified Registered Nurse Anesthetist (CRNA)
export const crnaProfessionCode = 73;

//Drug Enforcement Administration License (DEA)
export const deaCode  = 2;
